var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketmeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55559 16.9189L12.1419 17.7948L21.7282 18.6708C23.6599 18.7358 25.0587 19.5574 25.5109 20.8432C25.8809 21.8953 25.6429 22.986 24.9519 23.7982C24.1165 24.705 22.8385 25.1106 21.5389 24.8233L1.97875 20.5807C1.01046 20.352 0.377644 19.4361 0.524479 18.465C0.671314 17.4939 1.54939 16.8349 2.55559 16.9189Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55559 16.9189L12.1419 17.7948L21.7282 18.6708C23.6599 18.7358 25.0587 19.5574 25.5109 20.8432C25.8809 21.8953 25.6429 22.986 24.9519 23.7982C24.1165 24.705 22.8385 25.1106 21.5389 24.8233L1.97875 20.5807C1.01046 20.352 0.377644 19.4361 0.524479 18.465C0.671314 17.4939 1.54939 16.8349 2.55559 16.9189Z",
    fill: "url(#paint0_linear_2416_16832)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2849 21C42.2321 21 43.0073 20.2308 42.93 19.2868C42.6418 15.765 41.4683 12.3628 39.5065 9.40164C37.5447 6.4405 34.8694 4.03336 31.7387 2.39469C30.8995 1.95542 29.889 2.36929 29.5196 3.24152C29.1503 4.11376 29.5631 5.11298 30.3951 5.56556C32.9081 6.93243 35.0575 8.89694 36.647 11.2961C38.2365 13.6953 39.2074 16.4405 39.4862 19.2876C39.5785 20.2303 40.3377 21 41.2849 21Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.579 4.26228C32.0495 3.44018 31.767 2.38538 30.9092 1.98353C28.5429 0.87491 25.9857 0.215496 23.368 0.0446083C20.1788 -0.163599 16.9841 0.358895 14.0273 1.57228C11.0705 2.78567 8.42974 4.65794 6.30611 7.04644C4.56313 9.00681 3.20627 11.2725 2.30085 13.7238C1.97266 14.6123 2.51252 15.5615 3.42486 15.8161C4.33721 16.0707 5.27535 15.5334 5.61767 14.6503C6.37363 12.6999 7.47357 10.8957 8.86955 9.32562C10.6463 7.32726 12.8558 5.7608 15.3296 4.74561C17.8034 3.73042 20.4763 3.29327 23.1446 3.46747C25.2411 3.60433 27.2913 4.11575 29.1994 4.97287C30.0634 5.36099 31.1085 5.08438 31.579 4.26228Z",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2416_16832",
    x1: 7.28784,
    y1: 27.1712,
    x2: 13.8019,
    y2: 10.6368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E96114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B80000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketmeter);
export default __webpack_public_path__ + "static/media/marketmeter.5d99a5e88ef90c507ab62f2f5072aa97.svg";
export { ForwardRef as ReactComponent };